module.exports = {
    UpdateGuildSkillEvent: "UpdateGuildSkillEvent"//更新公会技能
    , UpdateSkillStatusEvent: "UpdateSkillStatusEvent"//更新指定技能状态
    , UpdateSkilUpgradeEvent: "UpdateSkilUpgradeEvent"//当前技能组全部激活成功之后，则升级技能组的事件
}